<template>
  <div class="actions-collapsed-list">
    <button
      class="btn btn-function exit-collapsed-list"
      @click="collapseActions"
    >
      <i
        v-tooltip.right.hover="$t('CANCEL')"
        class="glyphicon glyphicon-chevron-left"
        aria-hidden="true"
      />
    </button>

    <div class="action-icon">
      <button
        class="btn btn-list-function"
        @click="editPredictiveRouting"
      >
        <i
          v-tooltip.bottom.hover="$t('EDIT')"
          class="typcn typcn-edit"
          aria-hidden="true"
        />
        <span
          v-t="'EDIT'"
          class="hint-text-mobile"
        />
      </button>
    </div>
    <!-- Commenting out references action icon, will be coming on the heels of original deploy -->
    <!-- <div class="action-icon">
      <button
        :disabled="disabled"
        class="btn btn-list-function"
        @click="showPredictiveRoutingReferences"
      >
        <i
          v-tooltip.bottom.hover="$t('SHOW_REFERENCES')"
          class="typcn typcn-flow-children"
          aria-hidden="true"
        />
        <span
          v-t="'SHOW_REFERENCES'"
          class="hint-text-mobile"
        />
      </button>
    </div> -->
    <div class="action-icon">
      <button
        :disabled="disabled"
        class="btn btn-list-function m-t-3"
        @click="duplicatePredictiveRouting"
      >
        <i
          v-tooltip.bottom.hover="$t('DUPLICATE')"
          class="fa fa-files-o"
          aria-hidden="true"
        />
        <span
          v-t="'DUPLICATE'"
          class="hint-text-mobile"
        />
      </button>
    </div>
    <!-- Commenting out delete action icon, will be coming on the heels of original deploy -->
    <!-- <div class="action-icon">
      <button
        class="btn btn-list-function"
        :disabled="disabled"
        @click="deletePredictiveRouting(currentPredictiveRouting, $event)"
      >
        <i
          v-tooltip.bottom.hover="$t('DELETE')"
          class="typcn typcn-trash"
          aria-hidden="true"
        />
        <span
          v-t="'DELETE'"
          class="hint-text-mobile"
        />
      </button>
    </div> -->
  </div>
</template>

<script>
import ChangeLogObjectButtonAction from '@/core/components/ChangeLog/ChangeLogObjectButtonAction';
import messages from '../../locales';
import sharedMessages from '@/core/locales';

export default {
  name: 'PredictiveRoutingActions',
  components: {
    ChangeLogObjectButtonAction
  },
  props:{
    currentPredictiveRouting: {
      type: Object,
      default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods:{
    deletePredictiveRouting(id, e) {
      this.$emit('deletePredictiveRouting', id, e);
    },
    collapseActions() {
      this.$emit('collapseActions', this.currentPredictiveRouting.id);
    },
    editPredictiveRouting() {
      this.$emit('editPredictiveRouting', this.currentPredictiveRouting.id);
    },
    showPredictiveRoutingReferences(id, e) {
      this.$emit('showPredictiveRoutingReferences', id, e);
    },
    duplicatePredictiveRouting() {
      this.$emit('duplicatePredictiveRouting', this.currentPredictiveRouting.id);
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>